import React, { type MutableRefObject, type FunctionComponent } from 'react';
import { CLASS_NAMES } from './constants';
import useStickyPopover from './useStickyPopover';

export interface StickyProps {
  children: JSX.Element;
  content: JSX.Element;
}

const Sticky: FunctionComponent<StickyProps> = function ({
  children,
  content,
}) {
  const { ref, showPopover, popoverStyle } = useStickyPopover();

  return (
    <div ref={ref as MutableRefObject<HTMLDivElement>}>
      {content}
      {showPopover && (
        <div style={popoverStyle} className={CLASS_NAMES.popover}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Sticky;
